/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planninghorizonunlimited2Inputs */

const en_planninghorizonunlimited2 = /** @type {(inputs: Planninghorizonunlimited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No limit`)
};

const de_planninghorizonunlimited2 = /** @type {(inputs: Planninghorizonunlimited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Grenze`)
};

/**
* | output |
* | --- |
* | "No limit" |
*
* @param {Planninghorizonunlimited2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const planninghorizonunlimited2 = /** @type {((inputs?: Planninghorizonunlimited2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planninghorizonunlimited2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_planninghorizonunlimited2(inputs)
	return de_planninghorizonunlimited2(inputs)
});
export { planninghorizonunlimited2 as "planningHorizonUnlimited" }